import {
	filterCommonAttributes,
	type SearchAIAnalyticsContextDataInput,
} from './analytics-helpers';
import type { SearchAIAnalyticsContextLocation } from './search-ai-analytics-context-location';
import type { commonAttributesType } from './types';

/**
 * Builds `data` for {@link SearchAIAnalyticsContext}: merges {@link filterCommonAttributes} with `location`.
 * Allowlist sanitization runs only inside {@link SearchAIAnalyticsContext}.
 */
export const getSearchAIAnalyticsContextData = ({
	location,
	commonAttributes,
}: {
	location: SearchAIAnalyticsContextLocation;
	commonAttributes: commonAttributesType;
}): SearchAIAnalyticsContextDataInput => {
	const filtered = filterCommonAttributes(commonAttributes);
	return {
		location,
		attributes: {
			...filtered,
			location,
		},
	};
};
